import axios from 'axios';

export default class OpenStreetMapService {
	static instance;

	static getInstance() {
		if (!OpenStreetMapService.instance) {
			OpenStreetMapService.instance = new OpenStreetMapService();
		}

		return OpenStreetMapService.instance;
	}

    async getPointAddress(lng, lat) {
        return axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,{
            params: {}
        });
    }
}
